/**
 * DisplayItem > Review object.
 *
 * @typedef {Object} Review
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {Integer} rating The rating for the item (used by Bazaarvoice items only at the moment).
 * @property {Integer} ratingRange The rating range for the item (used by Bazaarvoice items only at the moment).
 * @property {Integer} reviewLikes The number of likes for the item (used by Bazaarvoice items only at the moment).
 * @property {String} productId Unknown! (possibly used by Bazaarvoice items only at the moment)
 * @property {String} metainfo Unknown! (possibly used by Bazaarvoice items only at the moment)
 * @property {String} classification Unknown! (possibly used by Bazaarvoice items only at the moment)
 * @property {String} context Unknown! (possibly used by Bazaarvoice items only at the moment)
 * @property {String} extendedProperties Unknown!
 */
class Review {

	constructor(rating, ratingRange, reviewLikes, productId, metainfo, classification, context, extendedProperties) {

		this.rating				= rating;
		this.ratingRange		= ratingRange;
		this.reviewLikes		= reviewLikes;
		this.productId			= productId;
		this.metainfo			= metainfo;
		this.classification		= classification;
		this.context			= context;
		this.extendedProperties	= extendedProperties;
	}
}

export default Review;